module.exports = __webpack_public_path__ + "static/adjustable-base-2-no-legs-123dbf7f2e22b82094bbe2001e98317f.png";